import React from "react";

interface Props {
  text: string;
  centered?: boolean;
}

const TemplateTypeTag: React.FC<Props> = ({ text, centered = false }) => {
  if (!text) {
    return null;
  }

  let backgroundColor = "#f6ffed";
  let color = "#237804";

  if (text.toLowerCase() === "email") {
    backgroundColor = "#f0f5ff";
    color = "#1d3764"; // blue-black
  } else if (text.toLowerCase() === "sms") {
    backgroundColor = "#f6ffed";
    color = "#237804"; // lemon green
  } else if (text.toLowerCase() === "pdf") {
    backgroundColor = "#fff0f6";
    color = "#eb2f96"; // magenta/pink
  }

  const tag = (
    <span
      style={{
        backgroundColor,
        color,
        padding: "4px 10px",
        display: "inline-block",
        textTransform: "uppercase",
      }}
    >
      {text}
    </span>
  );

  if (!centered) {
    return tag;
  }

  return (
    <span
      style={{
        width: "100%",
        display: "inline-flex",
        justifyContent: "center",
      }}
    >
      {tag}
    </span>
  );
};

export default TemplateTypeTag;
